import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { Credipago } from '../../shared/models/sale/credipago.model';
import { CredipagoDetail } from '../../shared/models/sale/credipago-detail.model';
import { CredipagoDetailFilterSet } from '../../shared/models/sale/credipago-detail-filter-set.model';
import { serialize } from '../../utility/serialize';
import { IPagedResult } from '../../shared/models/paged-result';
import { CredipagoEmail } from '../../shared/models/sale/credipago-email.model';
import { CredipagoClient } from '../../shared/models/sale/credipago-client.model';

export const credipagoApi = createApi({
  reducerPath: 'credipagoApi',
  baseQuery,
  endpoints: (builder) => ({
    createCredipago: builder.mutation<{ clientCode: string; credipagoCode: string }, Credipago>({
      query: (newCredipago) => ({
        url: '/api/credipagos',
        method: 'POST',
        body: newCredipago,
      }),
    }),
    getCredipagos: builder.query<IPagedResult<CredipagoDetail>, CredipagoDetailFilterSet>({
      query: (filterSet) => ({
        url: `/api/credipagos?${serialize(filterSet)}`,
        method: 'GET',
      }),
    }),
    sendEmail: builder.mutation<boolean, CredipagoEmail>({
      query: (emailCredipago) => ({
        url: '/api/credipagos/send-email',
        method: 'POST',
        body: emailCredipago,
      }),
    }),
    getCredipagosClient: builder.query<IPagedResult<CredipagoClient>, CredipagoDetailFilterSet>({
      query: (filterSet) => ({
        url: `/api/credipagos/client?${serialize(filterSet)}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useCreateCredipagoMutation,
  useLazyGetCredipagosQuery,
  useGetCredipagosQuery,
  useSendEmailMutation,
  useLazyGetCredipagosClientQuery,
} = credipagoApi;
